import React from 'react';
import numeral from 'numeral';
import { useRecoilValue } from 'recoil';
import { gsIsMobile } from '../../../AppState';
import { getSavings } from '../../../services/getSavings';
import formatCash from '../../../utilities/formatCash';

interface DetailsHighlightProps {
	price: number;
	bedrooms: number | undefined;
	bathroomsTotal: number | undefined;
	bathroomsFull: number | undefined;
	bathroomsHalf: number | undefined;
	area: string | undefined;
	closeDate: Date;
	savingsUrl: string;
	isRealtyApplied: boolean;
	countyId: number;
}


const DetailsHighlight = ({ price, bedrooms, bathroomsTotal, bathroomsFull, bathroomsHalf, area, closeDate, savingsUrl, isRealtyApplied, countyId }: DetailsHighlightProps) => {
	const [savingsArray, setSavingsArray] = React.useState<any>();
	const userOnMobile = useRecoilValue(gsIsMobile);

	const displayPrice = (
		userOnMobile ? (
			// If user on mobile, shorten price
			formatCash(price)
		) : (
			// Else show full price numeral
			numeral(price).format()
		)
	);

	async function generateSavings() {
		const [savingsJSON]: any[] = await getSavings(price, isRealtyApplied, countyId);
		setSavingsArray(savingsJSON);
	}

	React.useEffect(() => {
		if (countyId) {
			generateSavings();
		}
	}, [price, isRealtyApplied, countyId]);




	const SavingsFigure = () => {
		if (savingsArray) {
			const formattedSavings = numeral(savingsArray.MortgageSavings).format();
			return (
				<div>
					<span className="text-left">
						Save&nbsp;
						<a href={savingsUrl} rel="noopener noreferrer" target="_blank" className="text-decoration-underline cc-color--primary fw-bold">
						${formattedSavings}
						</a>
					</span>
				</div>
			);
		} else return <div className="text-center text--sm">{closeDate ? 'Sold' : 'Listing'} Price</div>;
	};

	return (
		<article className="d-flex align-items-center justify-content-between px-1 py-2 mb-3 mb-lg-0">
			<div className="leading-none">
				<h3 className="text-center mb-0">${displayPrice ? displayPrice : 0}</h3>
				<SavingsFigure />
			</div>
			<div className="property-details-highlight__vertical-rule" />
			<div className="leading-none text-center">
				<h3 className="mb-0">{bedrooms ? bedrooms : '--'}</h3>
				<div className="text--sm">Beds</div>
			</div>
			<div className="property-details-highlight__vertical-rule" />
			<div className="leading-none text-center">
				<h3 className="mb-0 d-flex align-items-baseline">
					{bathroomsTotal ? bathroomsTotal : '--'}&nbsp;
					<span className="font--base cc-font-weight--light">
						Bathroom{(bathroomsTotal && (bathroomsTotal > 1 || bathroomsTotal === undefined)) ? 's' : ''}
					</span>
				</h3>
				<div className="text--sm d-flex align-items-baseline">
					<span className="cc-font-weight--normal">{bathroomsFull && bathroomsFull > 0 ? bathroomsFull : '--'}</span>{' '}Full
					<div className="property-details-highlight__vertical-rule property-details-highlight__vertical-rule--small" />
					<span className="cc-font-weight--normal">{bathroomsHalf && bathroomsHalf > 0 ? bathroomsHalf : '--'}</span>{' '}Half
				</div>
			</div>
			<div className="property-details-highlight__vertical-rule" />
			<div className="leading-none text-center">
				<h3 className="mb-0">{area}</h3>
				<div className="text--sm">Sq. Feet</div>
			</div>
			<div></div>
		</article>
	);
};

export default DetailsHighlight;
